import clsx from 'clsx';

export type BadgeVariant =
  | 'primaryDark'
  | 'primaryLight'
  | 'secondaryDark'
  | 'secondaryLight'
  | 'outlineNeutral'
  | 'neutralDark'
  | 'neutralLight'
  | 'successDark'
  | 'successLight'
  | 'warningNeutral'
  | 'dangerNeutral';

export interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
}

export function Badge({
  className,
  variant = 'primaryDark',
  size = 'md',
  children,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center',
        'rounded-full',
        {
          'px-0.25 min-w-[0.5rem] min-h-[0.5rem] text-xs ml-[2px] mr-[2px]':
            size === 'xs',
          'px-0.5 min-w-[1.25rem] min-h-[1.25rem] text-xs': size === 'sm',
          'px-1 min-w-[1.5rem] min-h-[1.5rem] text-sm': size === 'md',
          'px-1.5 min-w-[2rem] min-h-[2rem] text-base': size === 'lg',
          'bg-primary-50 text-neutral-0': variant === 'primaryDark',
          'bg-primary-40 text-primary-60': variant === 'primaryLight',
          'bg-secondary-50 text-neutral-0': variant === 'secondaryDark',
          'bg-secondary-40 text-secondary-60': variant === 'secondaryLight',
          'bg-neutral-0 text-neutral-80 border-1 border-neutral-80':
            variant === 'outlineNeutral',
          'bg-neutral-80 text-neutral-0': variant === 'neutralDark',
          'bg-neutral-40 text-neutral-80': variant === 'neutralLight',
          'bg-success-50 text-neutral-0': variant === 'successDark',
          'bg-success-40 text-success-60': variant === 'successLight',
          'bg-warning-50': variant === 'warningNeutral',
          'bg-primary-60': variant === 'dangerNeutral',
        },
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
